export default __webpack_public_path__ + "static/media/36I-120235_-43774_0.ee29e7c2.jpg";